// extracted by mini-css-extract-plugin
export var inlineAlertWrapper = "InlineAlert-module--inline-alert-wrapper--2fd64";